module.exports = __webpack_public_path__ + "static/media/parte-savio.2f8ed8ed.png";